// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.careers-main-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: 768px) {
    .careers-main-container {
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
      gap: 20;
      padding: 10px 15px;
    }
  }
  .page-navigation-options-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 8px;
  }
  
  .page-navigation-options-container h3 {
    font-weight: 400;
    font-size: 30px;
  }
  
  @media screen and (min-width: 768px) {
    .page-navigation-options-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 20px 8px;
    }
    .page-navigation-options-container h3 {
      font-weight: 400;
      font-size: 25px;
    }
  }
  
  .page-navigation-options {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    border-radius: 25px;
    height: -moz-fit-content;
    height: fit-content;
    width: 100%;
    margin: auto;
  }
  .page-options-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-inline-start: 15px;
    margin-block-start: 10px;
    padding-bottom: 3%;
    margin-inline-end: 30px;
    /* flex:auto; */
  }
  
  @media screen and (min-width: 768px) {
    .page-navigation-options {
      margin-right: 18px;
      margin-top: 18px;
      width: 300px;
    }
  }
  @media screen and (min-width: 1024px) {
    .page-navigation-options {
      margin-right: 18px;
      margin-top: 18px;
    }
  }
  
  .careers-content-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 5px;
  }
  
  @media screen and (min-width: 768px) {
      .careers-content-container{
          align-items: flex-start;
          margin-top: 62px;
          padding: 10px 10px;
      }
  }
  
  .main-heading{
    font-weight: 500;
    font-size: 30px;
  }
  .main-heading-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    width: 90%;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Cookies/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE;MACE,mBAAmB;MACnB,uBAAuB;MACvB,uBAAuB;MACvB,OAAO;MACP,kBAAkB;IACpB;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,uBAAuB;MACvB,iBAAiB;IACnB;IACA;MACE,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,wBAAmB;IAAnB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE;MACE,kBAAkB;MAClB,gBAAgB;MAChB,YAAY;IACd;EACF;EACA;IACE;MACE,kBAAkB;MAClB,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;MACI;UACI,uBAAuB;UACvB,gBAAgB;UAChB,kBAAkB;MACtB;EACJ;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;EACZ","sourcesContent":[".careers-main-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  @media screen and (min-width: 768px) {\r\n    .careers-main-container {\r\n      flex-direction: row;\r\n      justify-content: center;\r\n      align-items: flex-start;\r\n      gap: 20;\r\n      padding: 10px 15px;\r\n    }\r\n  }\r\n  .page-navigation-options-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px 8px;\r\n  }\r\n  \r\n  .page-navigation-options-container h3 {\r\n    font-weight: 400;\r\n    font-size: 30px;\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n    .page-navigation-options-container {\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      align-items: flex-start;\r\n      padding: 20px 8px;\r\n    }\r\n    .page-navigation-options-container h3 {\r\n      font-weight: 400;\r\n      font-size: 25px;\r\n    }\r\n  }\r\n  \r\n  .page-navigation-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    border-radius: 25px;\r\n    height: fit-content;\r\n    width: 100%;\r\n    margin: auto;\r\n  }\r\n  .page-options-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    margin-inline-start: 15px;\r\n    margin-block-start: 10px;\r\n    padding-bottom: 3%;\r\n    margin-inline-end: 30px;\r\n    /* flex:auto; */\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n    .page-navigation-options {\r\n      margin-right: 18px;\r\n      margin-top: 18px;\r\n      width: 300px;\r\n    }\r\n  }\r\n  @media screen and (min-width: 1024px) {\r\n    .page-navigation-options {\r\n      margin-right: 18px;\r\n      margin-top: 18px;\r\n    }\r\n  }\r\n  \r\n  .careers-content-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding: 10px 5px;\r\n  }\r\n  \r\n  @media screen and (min-width: 768px) {\r\n      .careers-content-container{\r\n          align-items: flex-start;\r\n          margin-top: 62px;\r\n          padding: 10px 10px;\r\n      }\r\n  }\r\n  \r\n  .main-heading{\r\n    font-weight: 500;\r\n    font-size: 30px;\r\n  }\r\n  .main-heading-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    width: 90%;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
